import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";
import { pageMenuTabList04 } from "types/common";

import "assets/css/research.scss";

import {fnToggleBanner } from 'assets/js/commonUtil';
import { useEffect } from "react";

const Qc = () => {
  const { researchId } = useParams<{ researchId: string }>();
  pageMenuTabList04[1].on = true;

  useEffect(() => {  
    
    fnToggleBanner();
    
  }, []);

  return (
    <div className="page_content research">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/Quality-hero_1920x1080.jpg.jpg" imgText="품질인증" textcolor="#FFF"/>
      <PageTab props={pageMenuTabList04} />
      <div className="container">

        <div className="container-title">
          천호엔케어는 안심하고 먹을 수 있는 <span className="highlight">안전한 제품만을 생산</span>합니다.<br/>
          국가기관인증 안전관리 기준은 물론<br/>
          천호엔케어의 <span className="highlight">까다로운 자체 기준을 엄격히 준수</span>하고 있습니다.
        </div>
        
        <div className="container-item">
          <div className="container-item-title">품질인증 리스트</div>
          <div className='banner-wrapper'>
            
            <div className='qc-banner active'>
              <div className='top-title-text'>
                <div className="top-no">01</div>
                <div className='top-title'>HACCP</div>
                <div className="top-img"><img src="https://img.chunhomall.com/images/brand_site/Quality-section-01_300x300.png.png" alt="HACCP" /></div>
              </div>
              <div className="qc-banner-text">
                <div className='title-text'>HACCP</div>
                <div className='sub-title-text'>
                  식품안전관리인증기준 HACCP은 식품의
                  안전을 확보하기 위한 과학적 위생 관리 체계입니다.
                  천호엔케어에서 생산되고 있는 식품유형 전제품에
                  대하여 HACCP 인증을 완료하였습니다.
                </div>
              </div>
              <div className="qc-banner-img">
                <img src="https://img.chunhomall.com/images/brand_site/Quality-section-01_300x300.png.png" alt="HACCP" />
              </div>
            </div>
            
            <div className='qc-banner'>
              <div className='top-title-text'>
                <div className="top-no">02</div>
                <div className='top-title'>GMP</div>
                <div className="top-img"><img src="https://img.chunhomall.com/images/brand_site/Quality-section-02_300x300.png.png" alt="HACCP" /></div>
              </div>
              <div className="qc-banner-text">
                
                <div className='title-text'>GMP</div>
                <div className='sub-title-text'>
                  원료의 입고부터 출고까지 품질관리 전반에
                  지켜야 할 기준을 준수한 업체에 부여되는
                  인증 제도로, 천호엔케어는 매년 실시하는
                  정기조사 평가를 통과했습니다.
                </div>
              </div>
              <div className="qc-banner-img">
                <img src="https://img.chunhomall.com/images/brand_site/Quality-section-02_300x300.png.png" alt="HACCP" />
              </div>
            </div>
            <div className='qc-banner'>
              <div className='top-title-text'>
                <div className="top-no">03</div>
                <div className='top-title'>어린이 기호식품 품질인증</div>
                <div className="top-img"><img src="https://img.chunhomall.com/images/brand_site/Quality-section-03_300x300.png.png" alt="HACCP" /></div>
              </div>
              <div className="qc-banner-text">
                
                <div className='title-text'>어린이 기호식품 품질인증</div>
                <div className='sub-title-text'>
                  안전하고 영양을 고루 갖춘 어린이 기호
                  식품 품질인증을 획득하였습니다.
                </div>
              </div>
              <div className="qc-banner-img">
                <img src="https://img.chunhomall.com/images/brand_site/Quality-section-03_300x300.png.png" alt="HACCP" />
              </div>
            </div>
            <div className='qc-banner'>
              <div className='top-title-text'>
                <div className="top-no">04</div>
                <div className='top-title'>이력추적관리시스템</div>
                <div className="top-img"><img src="https://img.chunhomall.com/images/brand_site/Quality-section-04_300x300.png.png" alt="HACCP" /></div>
              </div>
              <div className="qc-banner-text">
                
                <div className='title-text'>이력추적관리시스템</div>
                <div className='sub-title-text'>
                  천호엔케어는 안전한 식품 선택을 위한
                  소비자의 알 권리를 보장하기 위해, 식품
                  의약품안전처에 일부 건강기능식품의 이력
                  추적정보를 등록하였습니다. 이력추적관리
                  시스템을 통해 건강기능식품의 제조·가공
                  단계부터 판매단계까지 이력추적정보를
                  기록·관리하고 있습니다.
                </div>
              </div>
              <div className="qc-banner-img">
                <img src="https://img.chunhomall.com/images/brand_site/Quality-section-04_300x300.png.png" alt="HACCP" />
              </div>
            </div>
            <div className='qc-banner'>
              <div className='top-title-text'>
                <div className="top-no">05</div>
                <div className='top-title'>FDA</div>
                <div className="top-img"><img src="https://img.chunhomall.com/images/brand_site/Quality-section-05_300x300.png.png" alt="HACCP" /></div>
              </div>
              <div className="qc-banner-text">
                
                <div className='title-text'>FDA</div>
                <div className='sub-title-text'>
                  미국에 판매되는 제품이 생산되는 식품
                  시설의 FDA 공장 등록을 완료하였습니다.
                  미국뿐 아니라 세계 곳곳에 제품을 수출
                  하며 전 세계인의 건강한 생활을 위해
                  힘쓰고 있습니다.
                </div>
              </div>
              <div className="qc-banner-img">
                <img src="https://img.chunhomall.com/images/brand_site/Quality-section-05_300x300.png.png" alt="HACCP" />
              </div>
            </div>
            <div className='qc-banner'>
              <div className='top-title-text'>
                <div className="top-no">06</div>
                <div className='top-title'>유기가공식품</div>
                <div className="top-img"><img src="https://img.chunhomall.com/images/brand_site/Quality-section-06_300x300.png.png" alt="HACCP" /></div>
              </div>
              <div className="qc-banner-text">
                
                <div className='title-text'>유기가공식품</div>
                <div className='sub-title-text'>
                  유기농 인증을 받은 농축산물을 95% 이상
                  사용한 가공식품 중에서 원료의 보관 및
                  취급, 제조설비 및 공정 위생, 포장, 사후
                  관리 등 모든 제조과정을 종합 판단하여
                  유기가공식품 인증을 획득하였습니다.
                </div>
              </div>
              <div className="qc-banner-img">
                <img src="https://img.chunhomall.com/images/brand_site/Quality-section-06_300x300.png.png" alt="HACCP" />
              </div>
            </div>
            <div className='qc-banner'>
              <div className='top-title-text'>
                <div className="top-no">07</div>
                <div className='top-title'>비건인증</div>
                <div className="top-img"><img src="https://img.chunhomall.com/images/brand_site/Quality-section-07_300x300.png.png" alt="HACCP" /></div>
              </div>
              <div className="qc-banner-text">
                
                <div className='title-text'>비건인증</div>
                <div className='sub-title-text'>
                  동물 유해 원재료를 사용하거나 이용하지
                  않고 교차 오염되지 않도록 관리하며,
                  제품에 동물실험을 실시하지 않는 기준
                  으로 부여하는 인증입니다.
                </div>
              </div>
              <div className="qc-banner-img">
                <img src="https://img.chunhomall.com/images/brand_site/Quality-section-07_300x300.png.png" alt="HACCP" />
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Qc;
